export const initMenu = function (parentEl) {
  const menuBtns = parentEl.querySelectorAll(".btn");
  menuBtns.forEach((btn) => btn.classList.remove("menu__btn--active"));
};

export const clear = function (el) {
  el.innerHTML = "";
};

export const createCompanyOptions = function (
  originalCompanyRows,
  selectCompany,
) {
  console.log(originalCompanyRows);
  //Create company options
  const options = originalCompanyRows.map((r) => ({
    id: r.companyId,
    text: `${r.company}`,
  }));
  console.log(options);

  //Render company options
  options.forEach((option) => {
    let element = document.createElement("option");
    element.textContent = option.text;
    element.value = option.text;
    element.dataset.companyId = option.id;
    selectCompany.appendChild(element);
  });
};

export const createCropOptions = function (originalCrop, selectCrop) {
  console.log(originalCrop);
  //Create crop options with id and text
  const options = originalCrop.map((r) => ({
    id: r.id || r.cropId, // Handle both new Supabase and old format
    text: `${r.crop_name || r.crop}`, // Handle both formats
  }));
  console.log(options);

  //Render crop options
  options.forEach((option) => {
    let element = document.createElement("option");
    element.textContent = option.text;
    element.value = option.text;
    element.dataset.cropId = option.id;
    selectCrop.appendChild(element);
  });
};
